import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './FilterOptions.module.css';

const FilterOptions = props => {
  const {
    spaceGroups,
    handleSearch,
    setSelectedCategory,
    selectedCategory,
    closeSideBar,
    setKeyword,
    setSortingOption
  } = props;
  
  const [isOpen, setIsOpen] = useState(true);
  const { records } = spaceGroups || {};

  const toggleVisibility = () => {
    setIsOpen(!isOpen);
  };

  const onSelectCategory = item => {
    handleSearch('space_group', item)
    setSelectedCategory(item);
    closeSideBar();
  };

  const handleClearAll = () => {
      setSelectedCategory('');
      setKeyword('');
      closeSideBar();
      setSortingOption('')
      handleSearch();
  };
  return (
    <>
      <div onClick={toggleVisibility} className={css.accordionHeading}>
        <div className={css.accordionTitle}>
          <FormattedMessage id="CircleFeedPage.categories" />
        </div>
        <span className={css.arrows}>{isOpen ? '-' : '+'}</span>
      </div>
      {isOpen && (
        <>
        {/* as per client requirement we are hiding the specific testing category */}
          <div className={css.accordionData}>
            {Array.isArray(records)
              ? records?.filter(item => item.id !== 615609)?.map(item => ( 
                  <div
                    className={css.spaceItems}
                    key={item.id}
                    onClick={() => onSelectCategory(String(item.id))}
                  >
                    <span
                      key={item.id}
                      value={item.slug}
                      className={
                        selectedCategory === String(item.id) ? css.selectedItem : css.unSelectedItem
                      }
                    >
                      {item.name}
                    </span>
                  </div>
                ))
              : null}
          </div>
          <div onClick={() => handleClearAll()}>
            <FormattedMessage id="CircleFeedPage.clearFilter" />
          </div>
          <div className={css.spacer}></div>
        </>
      )}
    </>
  );
};

export default FilterOptions;
